
import { Clock } from "lucide-react"
import { formatDbTimestampToLocal } from "@/lib/utils/date"
import { SleepCellBase } from "./SleepCellBase"
import { useMediaQuery } from "@/hooks/use-media-query"

interface SleepWindowCellProps {
  startTime: string
  endTime: string | null
  timezone?: string
}

export function SleepWindowCell({ startTime, endTime, timezone }: SleepWindowCellProps) {
  const isMobile = useMediaQuery("(max-width: 479px)")
  const isExtraSmall = useMediaQuery("(max-width: 360px)")
  
  // Format time more concisely on mobile
  const timeFormat = isExtraSmall ? "h:mm a" : "h:mm a" // Always show AM/PM for clarity
  
  const formattedStart = formatDbTimestampToLocal(startTime, timeFormat)
  const formattedEnd = endTime ? formatDbTimestampToLocal(endTime, timeFormat) : "TBD"
  
  return (
    <SleepCellBase icon={Clock} iconColor="text-blue-400">
      <span className="mobile-truncate xs:mobile-truncate-xs">
        {formattedStart} - {formattedEnd}
      </span>
    </SleepCellBase>
  )
}
